import StepTracker, { TrackerStep } from "../components/StepTracker";

export type ProjectStepKey = "deliverables" | "document-ai" | "compliance" | "findings";

/**
 * The stages a submission passes through, and NOT the audit trail.
 *
 * The audit trail used to sit here as a fifth step, which made the tracker say something untrue:
 * that a project is finished once somebody has read its own history. It is not a stage — nothing
 * about a submission advances by consulting it, and it is worth opening at any point rather than at
 * the end. It is now a button on the project header, and Findings is where the work ends.
 */
export const PROJECT_STEPS: TrackerStep<ProjectStepKey>[] = [
  { key: "deliverables", label: "Deliverables" },
  { key: "document-ai", label: "Document AI" },
  { key: "compliance", label: "Compliance Engine" },
  { key: "findings", label: "Findings" },
];

interface ProjectStepsProps {
  active: ProjectStepKey;
  onSelect: (key: ProjectStepKey) => void;
  /** Steps with real work behind them. Everything else stays grey — see the note below. */
  done?: ProjectStepKey[];
  /** Steps nothing could have produced anything for yet — dimmed, still reachable. */
  pending?: ProjectStepKey[];
}

/**
 * The project's stage tracker.
 *
 * A circle greens only when that stage has actually produced something — a tracker that ticked a
 * stage nothing had run would be the module reporting progress it has not made. The drawing of it is
 * the shared StepTracker, which the Standards workbench uses too.
 */
const ProjectSteps = ({ active, onSelect, done = [], pending = [] }: ProjectStepsProps) => (
  <StepTracker
    steps={PROJECT_STEPS}
    active={active}
    onSelect={onSelect}
    done={done}
    pending={pending}
  />
);

export default ProjectSteps;
